import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './lights-plan.module.scss';
export default class LightingOverView extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { lightingPointsDetails } = pageDetails || [];
        const { elevationImage } = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="" style={{marginTop: "15px", marginLeft: "10px"}}>
                    {
                        lightingPointsDetails && lightingPointsDetails.length ?
                <div className={styles.Table}>
                        {/* <div class="Title">
                            <p>This is a Table</p>
                        </div> */}
                        <div className={styles.Heading}>
                            <div className={styles.Cell}>
                                <p>POINT</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>PRODUCT NAME</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>TYPE</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>FIXTURE SIZE(in)</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>WATTAGE</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>LOOPED TO</p>
                            </div>
                            <div className={styles.Cell}>
                                <p>COLOR TEMP</p>
                            </div>
                        </div>
                        {
                           lightingPointsDetails && lightingPointsDetails.map(ele=>{
                                let {point, productName, type, fixtureSize, wattage, loopedTo, colorTemp} = ele;
                                return(
                                    <div className={styles.Row}>
                                        <div className={styles.Cell}>
                                            <p>{point ? point.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{productName ? productName.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{type ? type.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{fixtureSize ? fixtureSize.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{wattage ? wattage.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{(loopedTo && loopedTo.length )? loopedTo.join(',').toString().toUpperCase(): "NA"}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{colorTemp ? colorTemp.toString().toUpperCase(): "NA"}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div> :  null
                    }
                </div>
            </React.Fragment>

        )
    }

}